import getProductKey from 'helper/requests/getProductKey';
import {
  WindxPainelOption,
  CreateWindxModelParams,
  UpdateWindxModelParams,
} from 'types/Windx/Models/windxPainelOption';
import baseApi, { GenericResponse } from './base';

// CRUD admin de modelos do painel (WINDX-063 / ADR-042). Body JSON (sem upload).
// Mutações invalidam `WindxPainelOptions` (seletor do Painel + modal de Sim.
// Antigas) e `WindxModelosDisponiveis` (disponível/data) para refletir na hora.
const windxModelsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listWindxModels: build.query<WindxPainelOption[], void>({
      query: () => ({
        url: `produtos/windx/painel-options/admin/list/?product_key=${getProductKey('windx')}`,
        method: 'GET',
      }),
      transformResponse: (
        response: GenericResponse<WindxPainelOption[]>,
      ) => response.data,
      providesTags: ['WindxPainelOptions'],
    }),
    createWindxModel: build.mutation<
    GenericResponse<{ id: number; codigo: string }>, CreateWindxModelParams
    >({
      query: (body) => ({
        url: `produtos/windx/painel-options/admin/create/?product_key=${getProductKey('windx')}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['WindxPainelOptions', 'WindxModelosDisponiveis'],
    }),
    updateWindxModel: build.mutation<
    GenericResponse<unknown>, UpdateWindxModelParams
    >({
      query: ({ id, ...body }) => ({
        url: `produtos/windx/painel-options/admin/update/${id}/?product_key=${getProductKey('windx')}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['WindxPainelOptions', 'WindxModelosDisponiveis'],
    }),
    deleteWindxModel: build.mutation<
    GenericResponse<null>, number
    >({
      query: (id) => ({
        url: `produtos/windx/painel-options/admin/delete/${id}/?product_key=${getProductKey('windx')}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['WindxPainelOptions', 'WindxModelosDisponiveis'],
    }),
  }),
});

export const {
  useListWindxModelsQuery,
  useCreateWindxModelMutation,
  useUpdateWindxModelMutation,
  useDeleteWindxModelMutation,
} = windxModelsApi;
